import React from "react";
import "./Payment.css";
import Verified from "../Assets/verified.gif";

const Payment = () => {
  return (
    <div className="payment-cont">
      <div className="payment-box">
        <img src={Verified} alt="" />
        <h1>🎉Payment Successful!</h1>
        <p>
          Congratulations, your journey to <strong>faster,</strong>
          <strong>smarter,</strong> and better
          <strong> academic research</strong> starts now! We're thrilled to have
          you onboard.
        </p>
        <p>
          Your payment has been successfully processed, We will shortly get in
          touch with you.
        </p>
        <a href="/">Back To HomePage</a>
      </div>
    </div>
  );
};

export default Payment;
